'use strict';

export const searchAddressAutocompleteFieldElements = () => ({
    input: document.querySelector('input[name="where"]'),
    container: document.querySelector('div.where.autocomplete-container'),
    mapField: document.querySelector('div#map-field')
});